import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function AlertConfirm(props) {
  return (
    <SvgIcon {...props}>
      <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
        <path fillRule="evenodd" d="m18 10.6v5.4l1.3 1.3c0.6 0.6 0.2 1.7-0.7 1.7h-13.2c-0.9 0-1.3-1.1-0.7-1.7l1.3-1.3v-5c0-3.1 1.6-5.6 4.5-6.3v-0.7c0-0.8 0.7-1.5 1.5-1.5 0.8 0 1.5 0.7 1.5 1.5v0.7q1.2 0.3 2.1 0.9l-1.4 1.5q-0.9-0.6-2.2-0.6c-2.5 0-4 2-4 4.5v6h8v-4.5zm-2 1.8m-1.8-5.3m-4.2 12.9h4c0 1.1-0.9 2-2 2-1.1 0-2-0.9-2-2zm2.3-9.2l5.5-5.5 1.9 1.9-5.5 5.5q-0.1 0-0.2 0h-1.5c-0.1 0-0.2-0.1-0.2-0.2v-1.5q0-0.1 0-0.2zm7.9-4.1l-1.9-1.9 1-0.9q0-0.1 0.1-0.1 0.1-0.1 0.2-0.1 0.1 0 0.2 0.1 0.1 0 0.2 0.1l1.1 1.2c0.2 0.1 0.2 0.5 0 0.7zm-4.6-1.1" />
      </svg>
    </SvgIcon>
  );
}
